export default "__VITE_ASSET__6a3a1e10__"